import { Flex, Stack } from "@mantine/core";
import { useEffect } from "react";

import { useSalesContext } from "../../../sales-context/SalesContext";
import { useCallIntroStore, useVerificationFlowStore, useVerifiedCustomerStore } from "../../../stores";
import { CallIntroFlow } from "./call-intro-flow/CallIntroFlow";
import { CustomerOffers } from "./customer-offers/CustomerOffers";
import { CustomerProfile } from "./customer-profile/CustomerProfile";
import { CustomerVerification } from "./customer-verification/CustomerVerification";
import classes from "./CustomerPanel.module.css";

export function CustomerPanel() {
    const { sessionId, taskType, taskData, features } = useSalesContext();

    const isCustomerFlowComplete = useVerifiedCustomerStore(
        (state) => state.getVerifiedCustomer(sessionId).isCustomerVerificationComplete,
    );
    const { isPreviousSessionSummaryEnabled, isEnhancedCustomerSearchEnabled } = features;

    const stepHistory = useVerificationFlowStore((state) => state.getStepHistory(sessionId));
    const callIntroStep = useCallIntroStore((state) => state.currentStep);

    // Sync verification completion from step history
    useEffect(() => {
        const isFlowComplete =
            callIntroStep === "IntroFlowCompleted" || stepHistory.at(stepHistory.length - 1) === "VerificationComplete";
        if (isFlowComplete !== isCustomerFlowComplete) {
            useVerifiedCustomerStore.getState().setIsCustomerVerificationComplete(sessionId, isFlowComplete);
        }
    }, [stepHistory, callIntroStep, isCustomerFlowComplete, sessionId]);

    if (!taskType.isVoice && !taskType.isChat) {
        return undefined;
    }

    return (
        <Flex className={classes.customerPanel} data-testid="customer-panel">
            <Flex className={classes.responsivePanel}>
                <Flex className={classes.topSection}>
                    <CustomerProfile />
                </Flex>

                {!isCustomerFlowComplete ? (
                    isEnhancedCustomerSearchEnabled ? (
                        <CallIntroFlow />
                    ) : (
                        <CustomerVerification
                            mdnFromTask={taskData.mdn ?? ""}
                            isPreviousSessionSummaryEnabled={isPreviousSessionSummaryEnabled}
                        />
                    )
                ) : (
                    <Stack mt={"sm"}>
                        <CustomerOffers />
                    </Stack>
                )}
            </Flex>
        </Flex>
    );
}
